import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-4" }
const _hoisted_2 = { class: "col-sm-8 mx-auto" }
const _hoisted_3 = { class: "col-xxl-8 mx-auto" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xxl-6" }
const _hoisted_6 = { class: "col-xxl-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xxl-6" }
const _hoisted_9 = { class: "col-xxl-6" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_assets = _resolveComponent("assets")!
  const _component_income_and_pots = _resolveComponent("income-and-pots")!
  const _component_scenario = _resolveComponent("scenario")!
  const _component_page_nav = _resolveComponent("page-nav")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "skin-page-heading" }, "Dashboard Tracker", -1)),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.headerText), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_assets, {
        onGuaranteedIncomeChangeRequired: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$emit('guaranteed-income-change-required')
          ))
      }),
      _createVNode(_component_income_and_pots),
      _createVNode(_component_scenario, {
        scenario: _ctx.ScenarioType.AccordingToPlan,
        number: "1"
      }, null, 8, ["scenario"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_scenario, {
            scenario: _ctx.ScenarioType.LowerGrowth,
            number: "2"
          }, null, 8, ["scenario"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_scenario, {
            scenario: _ctx.ScenarioType.LiveThreeYearsLonger,
            number: "3"
          }, null, 8, ["scenario"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_scenario, {
            scenario: _ctx.ScenarioType.PotsFallTwentyPercent,
            number: "4"
          }, null, 8, ["scenario"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_scenario, {
            scenario: _ctx.ScenarioType.NeedExtraMoneyForLastTwoYears,
            number: "5"
          }, null, 8, ["scenario"])
        ]),
        (_ctx.showMainJourneyLink)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _cache[2] || (_cache[2] = [
              _createTextVNode(" If you want to change what you want in any way, "),
              _createElementVNode("a", { href: "/design" }, "click here to return to your Design", -1),
              _createTextVNode(". ")
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showPageNav)
      ? (_openBlock(), _createBlock(_component_page_nav, {
          key: 0,
          backLink: "finish",
          showNext: false,
          showCustom: true,
          customText: "Home",
          customLink: _ctx.parentCompanyLink
        }, null, 8, ["customLink"]))
      : _createCommentVNode("", true)
  ]))
}